import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ جلب جميع رسائل التواصل
export const getAllContactMessages = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params, // لو حبيت تضيف فلترة/صفحات مستقبلاً
  };

  try {
    const response = await api.get("/admin/contact-messages/all", {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching contact messages:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// ✅ تعليم رسالة تواصل كمقروءة
export const markContactMessageAsRead = async (messageId, params = {}) => {
  if (!messageId) {
    throw new Error("messageId is required.");
  }

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      `/admin/contact-messages/mark-as-read/${messageId}`,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error marking contact message as read:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};